module.exports = __webpack_public_path__ + "img/34.5bf39ab7.jpg";